<template>
    <div class="d-flex justify-center">
        <v-card class="note-page page pa-7 mb-16 pb-8" flat v-if="editableNote" style="width: 100%;">
            <v-card-text class='mt-5 mb-1'>
                <ButtonBack :button="{label: 'Notes'}" />
            </v-card-text>
            <div class="d-flex justify-space-between align-center flex-wrap">
                <div class="d-flex align-center flex-nowrap">
                    <Avatar class="mr-3" size="40" :avatar="editableNote.follow.user_logo" />
                    <div class="d-flex flex-column">
                        <v-card-title class="font-weight-bold username">
                            {{ editableNote.follow.visible_username }}
                        </v-card-title>
                        <v-card-subtitle class="pb-0">
                            {{ dateCreated(editableNote.note_updated) }}
                        </v-card-subtitle>
                    </div>
                </div>
                <v-card-actions>
                    <v-btn 
                        class="note-button-edit" 
                        color="transparent"
                        v-ripple="false"
                        @click="switchNoteFormModal"
                    >
                        Edit
                    </v-btn>
                    <v-btn 
                        class="note-button-remove ml-0"
                        color="transparent"
                        v-ripple="false"
                        @click="switchConfirmDeleteModal"
                    >
                        Remove
                    </v-btn>
                </v-card-actions>
            </div>
            <v-card-text class="note">
                {{ editableNote.follow_note }}
            </v-card-text>
        </v-card>
        <div v-if="isShowNoteFormModal">
			<NoteFormModal
				v-on:closeModal="switchNoteFormModal"
				:show="isShowNoteFormModal"
				:id="editableNote.follow_id"
                :note="editableNote.follow_note"
                :username="editableNote.username"
                :edit="true"
			/>
		</div>
        <div v-if="isShowConfirmDeleteModal">
            <ConfirmActionModal 
                v-on:closeModal="switchConfirmDeleteModal"
                v-on:confirmAction="removeNote"
                :show="isShowConfirmDeleteModal"
                :isLoading="isLoading"
                title="Are you sure you want to delete this note?"
                actionName="Delete"
            />
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Avatar from '@/components/Avatar'
import NoteFormModal from '@/components/Modals/NoteFormModal.vue'
import ConfirmActionModal from '../../components/Modals/ConfirmActionModal.vue'
import ButtonBack from '../../components/ButtonBack.vue'

export default {
    components: {
        Avatar,
        NoteFormModal,
        ConfirmActionModal,
        ButtonBack
    },
    data() {
        return {
            isShowNoteFormModal: false,
            isShowConfirmDeleteModal: false
        }
    },
    computed: {
        ...mapGetters('profile', ['editableNote', 'isLoading']),
    },
    watch: {
        editableNote(newValue, oldValue) {
            !newValue && oldValue && this.toNotesPage()
        }
    },
    methods: {
        ...mapActions('profile', ['updateEditableNote', 'deleteNote', 'getNoteById']),

        dateCreated(originalDate) {
            const date = new Date(originalDate * 1000)
            const options = { year: 'numeric', month: 'long', day: 'numeric' }
            return date.toLocaleDateString('en-US', options)
        },

        switchNoteFormModal() {
            this.isShowNoteFormModal = !this.isShowNoteFormModal
        },

        switchConfirmDeleteModal() {
            this.isShowConfirmDeleteModal = !this.isShowConfirmDeleteModal
        },

        toNotesPage() {
            this.$router.push({
                name: 'profile-notes'
            })
        },

        async removeNote() {
            await this.deleteNote(this.editableNote.follow_id)
        }
    },
    mounted() {
        !this.editableNote && this.toNotesPage()
    },
    beforeDestroy() {
        this.editableNote && this.updateEditableNote(null);
    }
}
</script>

<style lang="scss">
.v-card {
    &__title {
        font-size: 24px;
        color: #002855;
    }

    &__subtitle {
        font-size: 13px;
        color: #697583;
    }

    .username {
        word-break: break-word;
        color: var(--accent-color)
    }

    .note {
        margin-top: 30px;
    }
}

.note-button-edit, .note-button-remove {
    font-size: 14px;
    font-weight: 700;
    font-family: Montserrat;
    text-decoration: underline;
    text-transform: capitalize;

    &, &:active {
        box-shadow: none !important;
    }
}

div .note-button-edit {
    color: #0055A3 !important;
}

div .note-button-remove {
    color: #F35858 !important;
}
</style>
